'use client';

import { useState, useRef } from 'react';

// Assets
import IPlayVideo from '@public/svg/i-video';
import ISpeaker from '@public/svg/i-speaker';
import IUnmute from '@public/svg/i-unmute';
import IPause from '@public/svg/i-pause';

import useWindowSize from '@src/hooks/useWindowSize';

const Dedicated = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const videoRef = useRef(null);
  const { dd2XL } = useWindowSize();
  const [isHover, setIsHover] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (videoRef.current.paused || videoRef.current.ended) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  const _renderPlayButton = () => {
    if (isPlaying) {
      return isHover ? (
        <button
          onClick={togglePlay}
          className="absolute z-10 top-[40%] right-[50%] translate-x-1/2 translate-y-1/2 bg-white p-2 rounded-[8px] border border-solid border-[#040704] flex items-center justify-center"
        >
          <IPause width={50} height={50} />
        </button>
      ) : null;
    }
    return (
      <button
        onClick={togglePlay}
        className="absolute z-10 top-[40%] right-[50%] translate-x-1/2 translate-y-1/2 bg-white p-2 rounded-[8px] border border-solid border-[#040704] flex items-center justify-center"
      >
        <IPlayVideo width={50} height={50} />
      </button>
    );
  };

  if (dd2XL)
    return (
      <div
        className="pt-[64px] 
    dd2-2xl:px-6 
    dd2-xl:pt-6"
      >
        <p
          className="mb-[40px] text-[33px]/[39.6px] tracking-[-0.99px] font-satoshi-bold text-center 
      dd2-xl:mb-6 dd2-xl:text-start dd2-xl:text-[21px]/[25.2px] dd2-xl:tracking-[-0.42px]"
        >
          Tempat Ternyaman, Momen Berharga
        </p>

        <div className="flex items-center justify-center">
          <div
            className="relative w-[1344px] h-[756px] rounded-2xl 
        dd2-2xl:w-full dd2-2xl:h-[531px] 
        dd2-xl:h-[297px] 
        dd2-lg:h-[184px]"
          >
            <video
              controls={false}
              ref={videoRef}
              muted={true}
              autoPlay={true}
              playsInline={true}
              className="w-full h-full object-cover rounded-2xl"
              preload="metadata"
            >
              <source
                src="https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/homepage-video.mp4#t=0.1"
                type="video/mp4"
                className="rounded-2xl"
              />
            </video>
          </div>
        </div>
      </div>
    );
  return (
    <div
      className="pt-[64px] 
      dd2-2xl:px-6 
      dd2-xl:pt-6"
    >
      <p
        className="mb-[40px] text-[33px]/[39.6px] tracking-[-0.99px] font-satoshi-bold text-center 
        dd2-xl:mb-6 dd2-xl:text-start dd2-xl:text-[21px]/[25.2px] dd2-xl:tracking-[-0.42px]"
      >
        Tempat Ternyaman, Momen Berharga
      </p>

      <div
        className="flex items-center justify-center"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <div
          className="relative w-[1344px] h-[756px] rounded-2xl 
          dd2-2xl:w-full dd2-2xl:h-[531px] 
          dd2-xl:h-[297px] 
          dd2-lg:h-[184px]"
        >
          <div className="z-10 absolute top-[40px] right-[40px] flex items-center gap-6">
            <button
              onClick={() => setIsMuted(!isMuted)}
              className="bg-white p-2 rounded-[8px] border border-solid border-[#040704] flex items-center gap-1 text-[14px]/[19.6px] font-satoshi-bold"
            >
              Suara: {isMuted ? 'Tidak Aktif' : 'Aktif'}{' '}
              {isMuted ? (
                <ISpeaker width={12} height={12} />
              ) : (
                <IUnmute width={12} height={12} />
              )}
            </button>
          </div>
          {_renderPlayButton()}
          <video
            controls={false}
            ref={videoRef}
            muted={isMuted}
            className="w-full h-full object-cover rounded-2xl"
            preload="metadata"
          >
            <source
              src="https://s3.ap-southeast-1.amazonaws.com/production.storages/storages/store/century-21-indonesia/homepage-video.mp4#t=0.1"
              type="video/mp4"
              className="rounded-2xl"
            />
          </video>
        </div>
      </div>
    </div>
  );
};

export default Dedicated;
